export const getPrivilege = (serviceName) => {
  const privileges = JSON.parse(localStorage.getItem("service_privileges") || "{}");
  const role = localStorage.getItem("role");

  if (role === "CHAMP") return "FULL";

  return privileges[serviceName] || null;
};

export const canRead = (serviceName) => {
  const privilege = getPrivilege(serviceName);
  if (!privilege) return false;
  return ["READ", "WRITE", "FULL"].includes(privilege);
};

export const canWrite = (serviceName) => {
  const privilege = getPrivilege(serviceName);
  if (!privilege) return false;
  return ["WRITE", "FULL"].includes(privilege);
};